export class ProductType {
  id: number = null;
  name: string = null;
  description: string = null;
  parentProductTypeId: number = null;
}
